<div class="content md3-card-on-surface" style="margin-right: 0">
	<app-disposition-map3 [oeList]="SummaryData?.oeData"
	                      [places]="SummaryData?.schadenortData"
	                      [dispoDefinition]="SummaryData?.data?.DispositionListDefinitionValues"
	                      [taskObjects]="SummaryData.selectedObjects"
	                      [doDistanceMatrix]="mode === 'DL'"
	                      [busy]="busy"
	                      [isOverlay]="true"
	                      (OnAssign)="assignTasks($event)"
	                      (OnPlaceClick)="placeClick($event)"
	                      (OnSettingsChanged)="loadSummaryData()">
	</app-disposition-map3>
</div>
